import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';
import { reelsTotalTimeWatchedConfig } from '../reelsTotalTimeWatched';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const reelsTotalTimeWatchedMVConfig: KpiType<
    typeof MediaViewerKpiLoader,
    typeof MediaViewerKPI
> = {
    ...reelsTotalTimeWatchedConfig,
    name: 'kpi.facebook.total_time_watched',
    id: 'video_views_total_time',
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
